import React from 'react';
import { Box } from '@mui/material';

import styles from './DraggableElement.module.scss';

type DraggableElementProps = {
  children: React.ReactNode;
};

type HandleMouseDown = (e: React.MouseEvent, ref: React.RefObject<HTMLDivElement>) => void;

export type DraggableElementHandleMouseDown = HandleMouseDown;

const DraggableElement = ({ children }: DraggableElementProps) => {
  const handleMouseDown: HandleMouseDown = (e, ref) => {
    const chatElement = ref.current;
    if (!chatElement) return;

    const startX = e.clientX;
    const startY = e.clientY;
    const startLeft = chatElement.offsetLeft;
    const startTop = chatElement.offsetTop;

    const handleMouseMove = (moveEvent: MouseEvent) => {
      // Calculate the new position based on mouse movement
      const deltaX = moveEvent.clientX - startX;
      const deltaY = moveEvent.clientY - startY;

      let newLeft = startLeft + deltaX;
      let newTop = startTop + deltaY;

      // Apply boundary constraints to the final position
      const rightBoundary = window.innerWidth - chatElement.offsetWidth;
      const bottomBoundary = window.innerHeight - chatElement.offsetHeight;

      // Clamp the position within boundaries
      newLeft = Math.max(0, Math.min(newLeft, rightBoundary));
      newTop = Math.max(0, Math.min(newTop, bottomBoundary));

      chatElement.style.left = `${newLeft}px`;
      chatElement.style.top = `${newTop}px`;
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { handleMouseDown } as any);
    }
    return child;
  });

  return <Box className={styles.container}>{childrenWithProps}</Box>;
};

export default DraggableElement;
